import { isMobile } from "../helpers/isMobile";

const initialResourceWeb = (gameName) => {
  return {
    loading: {
      name: 'loading',
      path: `game/${gameName}/loading/web/loading.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/loading/web/loading.atlas`,
          imageNamePrefix: '_',
        },
      },
    }
  }
};

const initialResourceMobile = (gameName) => {
  return {
    loading: {
      name: 'loading',
      path: `game/${gameName}/loading/mobile/loading.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/loading/mobile/loading.atlas`,
          imageNamePrefix: '_',
        },
      },
    }
  }
};

export const initialGameResources = (gameName) => {
  return [
    ...Object.values(isMobile() ? initialResourceMobile(gameName) : initialResourceWeb(gameName)),
  ];
}
